import { useQuery, UseQueryResult } from '@tanstack/react-query'
import useDialog from 'hooks/Shared/useDialog'
import { useAppDispatch } from 'store/hooks'
import { ICFDISyncInformation } from 'store/SharedData/sharedData.models'
import { setCFDISyncInformation } from 'store/SharedData/sharedData.reducer'
import { IApiError } from 'services/Shared/shared.models'
import { getSyncInformation } from 'services/Invoices/invoices.services'

const useGetSyncInformation = (
  activeWorkspace: number
): UseQueryResult<ICFDISyncInformation[], IApiError> => {
  const dialog = useDialog()
  const dispatch = useAppDispatch()

  const query = useQuery<ICFDISyncInformation[], IApiError>(
    ['getSyncInformation', activeWorkspace],
    () => getSyncInformation(activeWorkspace),
    {
      refetchOnWindowFocus: false,
      onSuccess: data => {
        dispatch(setCFDISyncInformation(data))
      },
      onError: () => {
        dialog.danger({
          subtitle:
            'Ocurrió un error al obtener la información de sincronización.',
          primaryButtonText: 'Reintentar',
          secondaryButtonText: 'Cancelar',
          sideButtons: true,
          onPrimaryClick: () => query.refetch(),
        })
      },
    }
  )

  return query
}

export default useGetSyncInformation
